import styled, { css } from 'styled-components';

export const TopButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BackLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: ${({ theme }) => theme.colors.grey100};
  border: 1px solid ${({ theme }) => theme.colors.grey007};
  border-radius: 4px;
  text-decoration: none;

  &::after {
    content: ${'"\\e914"'};
    font-family: 'icomoon' !important;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.grey600};
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const extenedPageContainerStyle = css`
  padding: 16px 0;
`;
